export const orderType = {
  '00001': {
    flagInteriors: null,
    flagYarns: null,
    flagLoropianaFabrics: 'WB',
    flagSolbiatiFabrics: 'WB',
    flagShowRoom: null,
    flagShowRoom4: null,
    flagShowRoom5: null
  },
  '00401': {
    flagInteriors: null,
    flagYarns: null,
    flagLoropianaFabrics: 'WB',
    flagSolbiatiFabrics: 'WB',
    flagShowRoom: null,
    flagShowRoom4: null,
    flagShowRoom5: null
  },
  'US3': {
    flagInteriors: null,
    flagYarns: null,
    flagLoropianaFabrics: 'ZWEB',
    flagSolbiatiFabrics: 'ZWEB',
    flagShowRoom: null,
    flagShowRoom4: null,
    flagShowRoom5: null
  }
}







// WEBPACK FOOTER //
// ./src/utils/Property.js